export { LOCALES, LocaleEnum, localeEnglishName, localeNativeName, localeSchema } from "@repo/schema";
export const namespaces = [
    "common",
    "errors",
    "validation",
    "emails",
    "layout",
    "auth",
    "account",
    "project",
    "capture",
    "label",
    "model",
    "run",
    "device",
    "dashboard",
    "reports",
    "evaluation",
    "analytics",
    "camera",
];
export const defaultNamespace = "common";
//# sourceMappingURL=index.js.map